/**
 * Transaction Column Definitions
 * Defines all available columns for the transactions table with metadata
 * Required columns: Smart contract name (chain), Function name, Transaction time
 */

export const AVAILABLE_COLUMNS = {
  contract_name_chain: {
    label: 'Smart contract (chain)',
    field: 'contract_name_chain',
    category: 'core',
    default: true,
    required: true
  },
  function_name: {
    label: 'Function name',
    field: 'function_name',
    category: 'core',
    default: true,
    required: true
  },
  transaction_time: {
    label: 'Transaction time',
    field: 'transaction_time',
    category: 'core',
    formatter: 'time',
    default: true,
    required: true
  },
  tx_hash: {
    label: 'Tx Hash',
    field: 'tx_hash',
    category: 'core',
    default: true
  },
  block_no: {
    label: 'Block',
    field: 'block_no',
    category: 'blockchain'
  },
  from_address: {
    label: 'From',
    field: 'from_address',
    category: 'addresses'
  },
  to_address: {
    label: 'To',
    field: 'to_address',
    category: 'addresses'
  },
  value: {
    label: 'Value',
    field: 'value',
    category: 'blockchain',
    formatter: 'value'
  }
};

// Default columns configuration (required: contract_name_chain, function_name, transaction_time)
export const DEFAULT_COLUMNS = {
  enabled: ['contract_name_chain', 'function_name', 'transaction_time', 'tx_hash'],
  order: ['contract_name_chain', 'function_name', 'transaction_time', 'tx_hash']
};

// Column categories for organization
export const COLUMN_CATEGORIES = {
  core: 'Core',
  blockchain: 'Blockchain',
  addresses: 'Addresses'
};

/**
 * Get column definition by key
 */
export const getColumnDefinition = (columnKey) => {
  return AVAILABLE_COLUMNS[columnKey] || null;
};

/**
 * Get all available column keys
 */
export const getAvailableColumnKeys = () => {
  return Object.keys(AVAILABLE_COLUMNS);
};
